import Environment from "../utils/Environment";
import { uploadData } from "./UploadUtility";

const handleUpload = async (
  selectedDC: string,
  tabType: string,
  resetValues: () => void,
  files: File[],
  rowCount: number,
  setIsUploading: (value: boolean) => void,
  setAlertMessage: (message: string | null) => void,
  setAlertSeverity: (severity: 'success' | 'error' | 'info' | 'warning') => void,
  showSuccess: (msg?: string) => void,
  showError: (msg?: string) => void,
  onWaveRunning?: (waveData: any) => void,
  isProceed: boolean = false,
  userId?: string,
  createdtimestamp?: string
) => {
  console.log('handleUpload called with isProceed:', isProceed);
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  formData.append('dcName', selectedDC);
  if (tabType === 'IN02') {
    formData.append('isProceed', String(isProceed));
  }
  if (userId) {
    formData.append('createduser', userId);
  }
  if (createdtimestamp) {
    formData.append('createdtimestamp', createdtimestamp);
  }
  console.log('FormData isProceed value:', String(isProceed));

  // Get upload API based on tab type and selected DC
  let uploadAPI: string | undefined;
  let fileTypeLabel: string;
  
  switch (tabType) {
    case 'IN02':
      // Check combined IN02 DC first (e.g. WAUB)
      const combinedIN02DCs = Environment.getCombinedIN02DCList();
      const isCombinedIN02DC = selectedDC && combinedIN02DCs.includes(selectedDC);

      // Check if the selected DC is in the custom IN02 DC list
      const customIN02DCs = Environment.getCustomIN02DCList();
      const isCustomIN02DC = selectedDC && customIN02DCs.includes(selectedDC);

      if (isCombinedIN02DC) {
        uploadAPI = Environment.getUploadIN02CombinedAPI();
        fileTypeLabel = 'IN02';
      } else if (isCustomIN02DC) {
        uploadAPI = Environment.getUploadCustomIN02API();
        fileTypeLabel = 'Custom IN02';
      } else {
        uploadAPI = Environment.getUploadIN02API();
        fileTypeLabel = 'IN02';
      }
     break;
    case 'XDOCK':
    default:
      uploadAPI = Environment.getUploadAPI();
      fileTypeLabel = 'XDOCK';
      break;
  }

  await uploadData(
    uploadAPI,
    formData,
    resetValues,
    setIsUploading,
    setAlertMessage,
    setAlertSeverity,
    `${fileTypeLabel} File Uploaded successfully - ${rowCount} rows processed`,
    `${fileTypeLabel} File Upload failed (${rowCount} rows)`,
    showSuccess,
    showError,
    onWaveRunning
  );
};

export default handleUpload;
